import React, { useContext } from "react";
import lodash from "lodash";
import { Grid, Box, Typography, IconButton } from "@material-ui/core";
import {
  Brightness1Rounded,
  NotificationsOffRounded,
  NotificationsActiveRounded,
} from "@material-ui/icons";
import { useObserver } from "mobx-react-lite";

import { AuthStoreContext } from "../../contexts";
import {
  firebaseUpdateUserNotification,
  firebaseFetchUserProfile,
} from "../../firebase/user";

export default function DigitalStatus(props) {
  /**
  |--------------------------------------------------
  | Contexts
  |--------------------------------------------------
  */
  const authStore = useContext(AuthStoreContext);

  /**
  |--------------------------------------------------
  | Handlers
  |--------------------------------------------------
  */
  function getIsDisplayStatus(channel) {
    const displayAnalog = lodash.get(props.display, "digital", {});
    return displayAnalog[channel];
  }

  function getIsModbusDisplayStatus(channel) {
    const displayAnalog = lodash.get(props.display, "modbus_d", {});
    return displayAnalog[channel];
  }

  /**
   * FETCH USER PROFILE AFTER UPDATE SUBSCRIBE
   */
  async function onUpdateSub() {
    const userProfile = await firebaseFetchUserProfile(authStore.authUser.uid);
    authStore.setAuthUserProfile(userProfile);
  }

  /**
   * IS USER SUBSCRIBED
   */
  function isSub(channel) {
    const channelNumber = channel.replace("ch", "");

    const subChannel = lodash.get(
      authStore,
      `authUserProfile.notification.topic.${props.sensor.id}.di.${channelNumber}`,
      false
    );

    const subRegister = lodash.get(
      authStore,
      `authUserProfile.notification.topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_di_${channelNumber}.subscribe`,
      false
    );

    return subChannel && subRegister;
  }

  /**
   * SUBSCRIBE CHANNEL
   */
  async function handleSubScribe(channel) {
    const channelNumber = channel.replace("ch", "");
    let newNotification = lodash.cloneDeep(
      authStore.authUserProfile.notification
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.di.${channelNumber}`,
      true
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_di_${channelNumber}.subscribe`,
      true
    );

    firebaseUpdateUserNotification(authStore.authUser.uid, newNotification);
    onUpdateSub();
  }

  /**
   * UNSUBSCRIBE CHANNEL
   */
  async function handleUnSubScribe(channel) {
    const channelNumber = channel.replace("ch", "");
    let newNotification = lodash.cloneDeep(
      authStore.authUserProfile.notification
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.di.${channelNumber}`,
      false
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_di_${channelNumber}.subscribe`,
      false
    );

    firebaseUpdateUserNotification(authStore.authUser.uid, newNotification);
    onUpdateSub();
  }

  /**
   * IS USER SUBSCRIBED MODBUS
   */
  function isSubModbus(channel) {
    const channelNumber = channel.replace("ch", "");

    const subChannel = lodash.get(
      authStore,
      `authUserProfile.notification.topic.${props.sensor.id}.md.${channelNumber}`,
      false
    );

    const subRegister = lodash.get(
      authStore,
      `authUserProfile.notification.topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_md_${channelNumber}.subscribe`,
      false
    );

    return subChannel && subRegister;
  }

  /**
   * SUBSCRIBE DIGITAL MODBUS CHANNEL
   */
  async function handleModbusSubScribe(channel) {
    const channelNumber = channel.replace("ch", "");
    let newNotification = lodash.cloneDeep(
      authStore.authUserProfile.notification
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.md.${channelNumber}`,
      true
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_md_${channelNumber}.subscribe`,
      true
    );

    firebaseUpdateUserNotification(authStore.authUser.uid, newNotification);
    onUpdateSub();
  }

  /**
   * UNSUBSCRIBE DIGITAL MODBUS CHANNEL
   */
  async function handleModbusUnSubScribe(channel) {
    const channelNumber = channel.replace("ch", "");
    let newNotification = lodash.cloneDeep(
      authStore.authUserProfile.notification
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.md.${channelNumber}`,
      false
    );

    lodash.set(
      newNotification,
      `topic.${props.sensor.id}.registering.${props.factoryID}_${props.sensor.id}_md_${channelNumber}.subscribe`,
      false
    );

    firebaseUpdateUserNotification(authStore.authUser.uid, newNotification);
    onUpdateSub();
  }

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return useObserver(() => (
    <Grid item xs={12} md={6} style={{ marginBottom: "40px" }}>
      <p className="text-2xl " style={{ color: "#C4C4C4" }}>
        Digital sensor
      </p>
      <Box bgcolor="#373737" height="100%" borderRadius="8px">
        <Grid container style={{ marginTop: "10px" }}>
          <Grid
            item
            xs={12}
            className="flex flex-row"
            style={{ marginTop: "10px" }}
          >
            <Grid xs={3} item className="flex px-4 py-1" justify="space-around">
              <Box color="#6A6969">
                <Typography>Status</Typography>
              </Box>
            </Grid>
            <Grid xs={5} item alignItems="center" className="flex ">
              <Box className="mr-2" color="#6A6969">
                <Typography>Name</Typography>
              </Box>
            </Grid>
            <Grid item alignItems="center" className="flex justify-end " xs={3}>
              <Box className="mr-2" color="#6A6969">
                <Typography>Function</Typography>
              </Box>
            </Grid>
          </Grid>

          {/* STATUS ------------------------------------------------------------------------------------- */}
          {lodash.map(props.statuses, (status, key) => (
            <Grid key={key} item xs={12} className="px-4 py-1">
              <Box
                style={{
                  backgroundColor: "#303030",
                  borderRadius: "7px",
                  boxShadow: "1px 2px 4px rgba(0, 0, 0, 0.25)",
                }}
              >
                <Grid item xs={12} className="flex flex-row">
                  <Grid
                    xs={3}
                    container
                    alignItems="center"
                    className="flex "
                    justify="space-around"
                  >
                    {getIsDisplayStatus(status.channel) ? (
                      <Box color="#55fa3c" mr={2}>
                        <Brightness1Rounded color="inherit" />
                      </Box>
                    ) : (
                      <Box color="#A5A5A5" mr={2}>
                        <Brightness1Rounded color="inherit" />
                      </Box>
                    )}
                  </Grid>
                  <Grid
                    xs={5}
                    container
                    alignItems="center"
                    className="flex "
                    justify="start"
                  >
                    <div className="mr-2">
                      <Typography>{status.name}</Typography>
                    </div>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    className="flex justify-end "
                    xs={3}
                  >
                    {isSub(status.channel) ? (
                      <IconButton
                        onClick={() => handleUnSubScribe(status.channel)}
                      >
                        <NotificationsActiveRounded />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => handleSubScribe(status.channel)}
                      >
                        <NotificationsOffRounded />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ))}

          {/* MODBUS ------------------------------------------------------------------------------------- */}
          {lodash.map(props.modbus, (status, key) => (
            <Grid key={key} item xs={12} className="px-4 py-1">
              <Box
                style={{
                  backgroundColor: "#303030",
                  borderRadius: "7px",
                  boxShadow: "1px 2px 4px rgba(0, 0, 0, 0.25)",
                }}
              >
                <Grid item xs={12} className="flex flex-row">
                  <Grid
                    xs={3}
                    container
                    alignItems="center"
                    className="flex "
                    justify="space-around"
                  >
                    {getIsModbusDisplayStatus(status.channel) ? (
                      <Box color="#55fa3c" mr={2}>
                        <Brightness1Rounded color="inherit" />
                      </Box>
                    ) : (
                      <Box color="#A5A5A5" mr={2}>
                        <Brightness1Rounded color="inherit" />
                      </Box>
                    )}
                  </Grid>
                  <Grid
                    xs={5}
                    container
                    alignItems="center"
                    className="flex "
                    justify="start"
                  >
                    <div className="mr-2">
                      <Typography>{status.name} &nbsp;(mobus)</Typography>
                    </div>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    className="flex justify-end "
                    xs={3}
                  >
                    {isSubModbus(status.channel) ? (
                      <IconButton
                        onClick={() => handleModbusUnSubScribe(status.channel)}
                      >
                        <NotificationsActiveRounded />
                      </IconButton>
                    ) : (
                      <IconButton
                        onClick={() => handleModbusSubScribe(status.channel)}
                      >
                        <NotificationsOffRounded />
                      </IconButton>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Grid>
  ));
}
